/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, {PureComponent} from 'react'
import { Form } from 'semantic-ui-react'
import Select from 'react-select'
import _ from 'lodash'

export default class RestaurantField extends PureComponent {
  generateDropDownRestaurants = () => {
    const { restaurants } = this.props
    const selectOptions = []

    _.forEach(restaurants, restaurant => {
      if (restaurant.status === 'publish') {
        selectOptions.push({
          label: restaurant.name,
          value: restaurant.key,
        })
      }
    })

    return selectOptions
  }

  render() {
    const { onChange, value }= this.props

    const options = this.generateDropDownRestaurants()

    return (
      <Form.Field required>
        <label>Restaurant</label>
        <Select
          required
          menuPlacement="bottom"
          isSearchable
          placeholder="Please choose restaurant"
          onChange={res => onChange(res.value)}
          defaultValue={_.find(options, item => item.value === value)}
          options={options}
        />
      </Form.Field>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/specialDeal/fields/restaurantsField.js